import React, { useContext } from "react";
import { Box, Typography } from "@mui/material";
import { format, parseISO } from "date-fns";

// Local Imports
import SingleStepper from "components/reusable/AdxProgressStepper/SingleStepper";
import DefaultAvatar from "assets/images/default_avatar.png";
import { authContext } from "contexts/AuthContext";

const CreditApproval = ({ approvalArr, requestItem }) => {
  const { data: authData } = useContext(authContext).auth;
  const [
    submittedLayer,
    confirmationLayer,
    submittedLayer2,
    ...remainingLayer
  ] = approvalArr || [];

  return (
    <Box sx={{ my: 2.25, minHeight: "20vh" }}>
      <SingleStepper
        active={true}
        activeSubtitle="Submitted"
        name={
          authData.staff.name === submittedLayer.request_from
            ? "Me"
            : submittedLayer.request_from
        }
        imgUrl={submittedLayer.request_from_image || DefaultAvatar}
        date={
          submittedLayer?.updated_at
            ? format(
              parseISO(submittedLayer?.updated_at),
              `dd/MM/yyyy, hh:mmaa`
            )
            : null
        }
      />
      <SingleStepper
        active={
          confirmationLayer?.approval_status === 13 ||
            confirmationLayer?.approval_status === 11
            ? true
            : false
        }
        activeSubtitle={
          confirmationLayer?.approval_status === 11 ? (
            <Typography
              noWrap
              component="span"
              variant="body2"
              color="error.main"
              fontWeight="bold"
              textTransform="capitalize"
            >
              Rejected
            </Typography>
          ) : requestItem?.status === 16 ? (
            "No further action needed"
          ) : (
            confirmationLayer?.approval_status_name
          )
        }
        name={confirmationLayer?.approver.map((el) =>
          el.name === authData.staff.name ? "Me" : el.name
        )}
        inactiveSubtitle={
          requestItem?.status === 16
            ? "No further action needed"
            : confirmationLayer?.approval_status_name
        }
        imgUrl={
          confirmationLayer?.approver.map((el) =>
            el.image ? el.image : DefaultAvatar
          ) || DefaultAvatar
        }
        date={
          confirmationLayer?.updated_at
            ? format(
              parseISO(confirmationLayer?.updated_at),
              `dd/MM/yyyy, hh:mmaa`
            )
            : null
        }
      />
      <SingleStepper
        active={
          confirmationLayer?.approval_status === 11 ||
            confirmationLayer?.approval_status === 12
            ? false
            : true
        }
        inactiveSubtitle={
          requestItem?.status === 11 || requestItem?.status === 16
            ? "No further action needed"
            : confirmationLayer?.approval_status === 12
              ? "Awaiting confirmation"
              : "Awaiting supporting document. Click the button below to submit."
        }
        activeSubtitle={
          requestItem?.status === 14
            ? "Awaiting supporting document. Click the button below to submit."
            : "Submitted Documentation"
        }
        name={
          authData.staff.name === submittedLayer2.request_from
            ? "Me"
            : submittedLayer2.request_from
        }
        imgUrl={submittedLayer2.request_from_image || DefaultAvatar}
        date={
          submittedLayer2?.updated_at
            ? format(
              parseISO(submittedLayer2?.updated_at),
              `dd/MM/yyyy, hh:mmaa`
            )
            : null
        }
      />
      {remainingLayer.map((item, index, arr) => (
        <SingleStepper
          key={index}
          active={
            item?.approval_status === 17 || item?.approval_status === 11
              ? true
              : false
          }
          activeSubtitle={
            item.approval_status === 11 ? (
              <Typography
                noWrap
                component="span"
                variant="body2"
                color={"error.main"}
                fontWeight="bold"
                textTransform="capitalize"
              >
                {item?.approval_status_name}
              </Typography>
            ) : (
              item?.approval_status_name
            )
          }
          disableLine={remainingLayer.length - 1 === index}
          inactiveSubtitle={
            requestItem?.status === 11 || requestItem?.status === 16
              ? "No further action needed"
              : index - 1 >= 0 && arr[index - 1].approval_status === 1
                ? `Awaiting approval by previous layer`
                : "Awaiting approval"
          }
          name={
            item.approval_status === 17 || item?.approval_status === 11
              ? item.approved_by
              : item.approver.map((el) =>
                el.name === authData.staff.name ? "Me" : el.name
              )
          }
          imgUrl={
            item.approval_status === 17 || item?.approval_status === 11
              ? item.approved_by_image
              : item.approver.map((el) =>
                el.image ? el.image : DefaultAvatar
              ) || DefaultAvatar
          }
          date={
            item.updated_at
              ? format(parseISO(item.updated_at), `dd/MM/yyyy, hh:mmaa`)
              : null
          }
        />
      ))}
    </Box>
  );
};

export default CreditApproval;
